import TopTicker from './components/TopTicker';
import SiteHeader from './components/SiteHeader';
import CoverHero from './components/CoverHero';
import StatStrip from './components/StatStrip';
import TopicWall from './components/TopicWall';
import HeatRanking from './components/HeatRanking';
import OpinionClash from './components/OpinionClash';
import CommentPicks from './components/CommentPicks';
import FollowUpTimeline from './components/FollowUpTimeline';
import ControversyFocus from './components/ControversyFocus';
import SubscribeShell from './components/SubscribeShell';
import SiteFooter from './components/SiteFooter';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopTicker />
      <SiteHeader />
      <main>
        <CoverHero />
        <StatStrip />
        <TopicWall />
        <HeatRanking />
        <OpinionClash />
        <CommentPicks />
        <FollowUpTimeline />
        <ControversyFocus />
        <SubscribeShell />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}